import { render, staticRenderFns } from "./plan.vue?vue&type=template&id=28b38859&scoped=true&"
import script from "./plan.js?vue&type=script&lang=js&"
export * from "./plan.js?vue&type=script&lang=js&"
import style0 from "./plan.vue?vue&type=style&index=0&id=28b38859&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b38859",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28b38859')) {
      api.createRecord('28b38859', component.options)
    } else {
      api.reload('28b38859', component.options)
    }
    module.hot.accept("./plan.vue?vue&type=template&id=28b38859&scoped=true&", function () {
      api.rerender('28b38859', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/plan/plan.vue"
export default component.exports